import React from 'react';

import { PriorityDotProps } from './PriorityDot.props';
import { TablePill, toneForPriority } from '../TablePill';

/**
 * A priority, wherever one is shown outside a list table.
 *
 * Like `StatusBadge`, an adapter over `TablePill` rather than its own palette.
 * The tone comes from the colour configured against the priority where there is
 * one, and from its name where there is not — so "Critical" still reads as
 * critical on a panel that never receives a colour.
 *
 * Uppercased, because the values are not consistently cased across the data
 * (Hso, Sup, P2, SCH beside Critical and High) and a column of them read as a
 * set of one-offs.
 */
export const PriorityDot: React.FC<PriorityDotProps> = ({ priority, color }) => (
  <TablePill tone={toneForPriority(priority, color)} size="md" ariaLabel={`Priority: ${priority}`}>
    {priority.toUpperCase()}
  </TablePill>
);
